
if (typeof checkSession !== 'undefined' && checkSession) {
    (function ($) {
        const SESSION_URL = basePath + '/wp-json/mega-pathway/v1/session';
        const LOGOUT_URL = fullBase + '/logout';

        const WARNING_SECONDS = 60;
        const SAFETY_SECONDS = 5;

        const MIN_CHECK_MS = 15 * 1000;
        const TOUCH_THROTTLE_MS = 60 * 1000;
        const ACTIVITY_WRITE_THROTTLE_MS = 5 * 1000;

        const LEADER_TTL_MS = 45 * 1000;
        const LEADER_REFRESH_MS = 15 * 1000;

        const TAB_ID = Date.now() + '-' + Math.random().toString(16).slice(2);

        const HAS_LOCKS = !!(navigator.locks && navigator.locks.request);
        let lockHeld = false;

        const KEYS = {
            leader: 'mefa_session_leader',
            lastActivity: 'mefa_session_last_activity',
            lastTouch: 'mefa_session_last_touch',
            logout: 'mefa_session_logout',
            warn: 'mefa_session_warn',
            expires: 'mefa_session_expires_at'
        };

        const WARNING_MESSAGE =
            "<p>You will be logged out in 1 minute due to inactivity.</p>" +
            "<p><a href='#' class='btn primary continue'>Continue</a> " +
            "<a href='" + LOGOUT_URL + "' class='btn secondary'>Logout</a></p>";

        let checkTimer = null;
        let warnTimer = null;
        let logoutTimer = null;
        let leaderTimer = null;

        let requestInFlight = false;
        let pendingTouch = false;
        let warningVisible = false;
        let lastLocalActivity = 0;

        let lastWakeCheck = 0;
        const WAKE_CHECK_THROTTLE_MS = 60 * 1000;

        function now() {
            return Date.now();
        }

        function safeParse(value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return null;
            }
        }

        function setStorage(key, value) {
            try {
                localStorage.setItem(key, JSON.stringify(value));
            } catch (e) {}
        }

        function getStorage(key) {
            try {
                return safeParse(localStorage.getItem(key));
            } catch (e) {
                return null;
            }
        }

        function removeStorage(key) {
            try {
                localStorage.removeItem(key);
            } catch (e) {}
        }

        function redirectLogout(reason) {
            if (reason === 3) {
                window.location.replace(fullBase + '/logout/');
            } else {
                window.location.replace(fullBase + '?logged-out=' + encodeURIComponent(reason || 1));
            }
        }

        function clearTimers() {
            if (checkTimer) clearTimeout(checkTimer);
            if (warnTimer) clearTimeout(warnTimer);
            if (logoutTimer) clearTimeout(logoutTimer);
            if (leaderTimer) clearInterval(leaderTimer);

            checkTimer = null;
            warnTimer = null;
            logoutTimer = null;
            leaderTimer = null;
        }

        function showWarning(secondsRemaining) {
            if (!warningVisible) {
                addOverlay('timeout', WARNING_MESSAGE);
                warningVisible = true;
            }

            setStorage(KEYS.warn, {
                tab: TAB_ID,
                at: now(),
                seconds_remaining: secondsRemaining || WARNING_SECONDS
            });
        }

        function hideWarning() {
            if (!warningVisible) return;
            warningVisible = false;
            $('#overlay').remove();
        }

        function performLogout(reason) {
            setStorage(KEYS.logout, {
                tab: TAB_ID,
                at: now(),
                reason: reason || 1
            });

            removeStorage(KEYS.expires);
            removeStorage(KEYS.warn);
            removeStorage(KEYS.lastActivity);
            removeStorage(KEYS.lastTouch);
            removeStorage(KEYS.leader);

            clearTimers();
            redirectLogout(reason || 1);
        }

        function announceLogout(reason) {
            setStorage(KEYS.logout, {
                tab: TAB_ID,
                at: now(),
                reason: reason || 1
            });

            removeStorage(KEYS.expires);
            removeStorage(KEYS.warn);
            removeStorage(KEYS.lastActivity);
            removeStorage(KEYS.lastTouch);
            removeStorage(KEYS.leader);

            clearTimers();

            var opts = {
                type: 'DELETE',
                url: SESSION_URL,
                dataType: 'json',
                complete: function() { redirectLogout(reason || 1); }
            };
            if (wp_vars && wp_vars.session_nonce) {
                opts.headers = { 'X-FW-Nonce': wp_vars.session_nonce };
            }
            $.ajax(opts);
        }

        function isLeader() {
            if (HAS_LOCKS) {
                return lockHeld;
            }

            const leader = getStorage(KEYS.leader);

            if (leader && leader.tab === TAB_ID && leader.expires > now()) {
                return true;
            }

            if (!leader || !leader.expires || leader.expires < now()) {
                const claim = {
                    tab: TAB_ID,
                    expires: now() + LEADER_TTL_MS
                };

                setStorage(KEYS.leader, claim);

                const verified = getStorage(KEYS.leader);

                return !!(
                    verified &&
                    verified.tab === TAB_ID &&
                    verified.expires === claim.expires
                );
            }

            return false;
        }

        function renewLeadership() {
            if (isLeader()) {
                setStorage(KEYS.leader, {
                    tab: TAB_ID,
                    expires: now() + LEADER_TTL_MS
                });
            }
        }

        function scheduleNextCheck(secondsRemaining) {
            if (checkTimer) clearTimeout(checkTimer);

            if (!isLeader()) {
                return;
            }

            secondsRemaining = parseInt(secondsRemaining || 0, 10);

            let nextMs;

            if (!secondsRemaining || secondsRemaining <= WARNING_SECONDS) {
                nextMs = MIN_CHECK_MS;
            } else {
                nextMs = (secondsRemaining - WARNING_SECONDS - SAFETY_SECONDS) * 1000;
            }

            nextMs = Math.max(MIN_CHECK_MS, nextMs);

            checkTimer = setTimeout(checkSessionStatus, nextMs);
        }

        function applyClientTimers(secondsRemaining) {
            clearTimeout(warnTimer);
            clearTimeout(logoutTimer);

            secondsRemaining = parseInt(secondsRemaining || 0, 10);

            if (!secondsRemaining || secondsRemaining <= 0) {
                return;
            }

            const warnMs = Math.max(0, (secondsRemaining - WARNING_SECONDS) * 1000);
            const logoutMs = Math.max(0, secondsRemaining * 1000);

            warnTimer = setTimeout(function () {
                showWarning(WARNING_SECONDS);
            }, warnMs);

            logoutTimer = setTimeout(function () {
                announceLogout(1);
            }, logoutMs + 1000);
        }

        function scheduleClientTimers(secondsRemaining) {
            secondsRemaining = parseInt(secondsRemaining || 0, 10);

            if (!secondsRemaining || secondsRemaining <= 0) {
                return;
            }

            const expiresAt = now() + secondsRemaining * 1000;

            setStorage(KEYS.expires, {
                tab: TAB_ID,
                at: now(),
                expires_at: expiresAt
            });

            applyClientTimers(secondsRemaining);
        }

        function ajaxSession(method, onSuccess) {
            if (requestInFlight) return;

            requestInFlight = true;

            var options = {
                type: method,
                url: SESSION_URL,
                dataType: 'json',
                cache: false,
                timeout: 10000,
                success: function (data) {
                    if (typeof onSuccess === 'function') {
                        onSuccess(data || {});
                    }
                },
                error: function () {
                    if (isLeader()) {
                        scheduleNextCheck(120);
                    }
                },
                complete: function () {
                    requestInFlight = false;
                    if (pendingTouch) {
                        pendingTouch = false;
                        touchSession(true);
                    }
                }
            };

            if ((method === 'POST' || method === 'DELETE') && wp_vars && wp_vars.session_nonce) {
                options.headers = { 'X-FW-Nonce': wp_vars.session_nonce };
            }

            $.ajax(options);
        }

        function handleSessionResponse(data) {
            if (!data || !data.response) return;
            if (getStorage(KEYS.logout)) return;

            if (
                data.response === 'logout' ||
                data.response === 'empty-session' ||
                data.response === 'session-error'
            ) {
                announceLogout(1);
                return;
            }

            const secondsRemaining = parseInt(data.seconds_remaining || 0, 10);

            if (secondsRemaining > 0) {
                scheduleClientTimers(secondsRemaining);
            }

            if (data.response === 'alert') {
                if (!pendingTouch) {
                    showWarning(secondsRemaining || WARNING_SECONDS);
                }
                scheduleNextCheck(secondsRemaining || WARNING_SECONDS);
                return;
            }

            if (data.response === 'ok') {
                clearStaleSessionState();
                hideWarning();
                scheduleNextCheck(secondsRemaining || 300);
            }
        }

        function checkSessionStatus() {
            renewLeadership();

            if (!isLeader()) {
                return;
            }

            if (getStorage(KEYS.logout)) {
                return;
            }

            ajaxSession('GET', handleSessionResponse);
        }

        function touchSession(force) {
            if (!isLeader()) {
                return;
            }

            if (getStorage(KEYS.logout)) {
                return;
            }

            const lastTouch = getStorage(KEYS.lastTouch);
            const lastTouchAt = lastTouch && lastTouch.at ? lastTouch.at : 0;

            if (!force && now() - lastTouchAt < TOUCH_THROTTLE_MS) {
                return;
            }

            setStorage(KEYS.lastTouch, {
                tab: TAB_ID,
                at: now()
            });

            if (requestInFlight) {
                pendingTouch = true;
                return;
            }

            ajaxSession('POST', handleSessionResponse);
        }

        function recordActivity() {
            const t = now();

            if (t - lastLocalActivity < ACTIVITY_WRITE_THROTTLE_MS) {
                return;
            }

            lastLocalActivity = t;

            setStorage(KEYS.lastActivity, {
                tab: TAB_ID,
                at: t,
                user: true
            });

            touchSession(false);
        }

        function apiLogout(reason) {
            clearTimers();
            hideWarning();

            var options = {
                type: 'DELETE',
                url: SESSION_URL,
                dataType: 'json',
                complete: function () {
                    performLogout(reason || 1);
                }
            };
            if (wp_vars && wp_vars.session_nonce) {
                options.headers = { 'X-FW-Nonce': wp_vars.session_nonce };
            }
            $.ajax(options);
        }

        function syncTimersFromStoredExpiration() {
            const stored = getStorage(KEYS.expires);

            if (!stored || !stored.expires_at) {
                return;
            }

            const secondsRemaining = Math.floor((stored.expires_at - now()) / 1000);

            if (secondsRemaining <= 0) {
                announceLogout(1);
                return;
            }

            if (secondsRemaining <= WARNING_SECONDS + SAFETY_SECONDS) {
                return;
            }

            scheduleClientTimers(secondsRemaining);
        }

        function handleStorageEvent(event) {
            if (event.key === KEYS.logout) {
                const logout = safeParse(event.newValue);

                if (logout && logout.tab !== TAB_ID) {
                    clearTimers();
                    redirectLogout(logout.reason || 1);
                }
            }

            if (event.key === KEYS.warn) {
                const warn = safeParse(event.newValue);

                if (warn && warn.tab !== TAB_ID) {
                    showWarning(warn.seconds_remaining || WARNING_SECONDS);
                }
            }

            if (event.key === KEYS.expires) {
                const expires = safeParse(event.newValue);

                if (expires && expires.tab !== TAB_ID && expires.expires_at) {
                    const secondsRemaining = Math.floor((expires.expires_at - now()) / 1000);

                    if (secondsRemaining <= 0) {
                        announceLogout(1);
                    } else {
                        applyClientTimers(secondsRemaining);
                    }
                }
            }

            if (event.key === KEYS.lastActivity) {
                const activity = safeParse(event.newValue);

                if (
                    activity &&
                    activity.tab !== TAB_ID &&
                    activity.user === true &&
                    now() - activity.at < 10000 &&
                    isLeader()
                ) {
                    touchSession(false);
                }
            }

            if (event.key === KEYS.leader) {
                const leader = safeParse(event.newValue);

                if (!leader || !leader.expires || leader.expires < now()) {
                    if (isLeader()) {
                        checkSessionStatus();
                    }
                }
            }
        }

        function bindEvents() {
            $(document).on(
                'click keydown scroll touchstart pointerdown',
                recordActivity
            );

            $(window).on('storage', function (e) {
                const event = e.originalEvent;
                if (!event) return;

                setTimeout(function () {
                    handleStorageEvent(event);
                }, 0);
            });

            window.addEventListener('beforeunload', function () {
                const leader = getStorage(KEYS.leader);

                if (leader && leader.tab === TAB_ID) {
                    removeStorage(KEYS.leader);
                }
            });

            $(window).on('focus', function () {
                validateOnWake();
            });

            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) {
                    validateOnWake();
                }
            });


            $(document).on('click', 'a[href$="/logout"]', function (e) {
                e.preventDefault();
                apiLogout(3);
            });
        }

        function validateOnWake() {
            const stored = getStorage(KEYS.expires);
            const logout = getStorage(KEYS.logout);

            if (stored && stored.expires_at && stored.expires_at <= now()) {
                announceLogout(1);
                return;
            }

            if (logout && logout.at && now() - logout.at < 10 * 60 * 1000) {
                redirectLogout(logout.reason || 1);
                return;
            }

            if (!isLeader()) {
                return;
            }

            if (now() - lastWakeCheck < WAKE_CHECK_THROTTLE_MS) {
                return;
            }

            lastWakeCheck = now();
            checkSessionStatus();
        }

        function initSessionManager() {
            removeStorage(KEYS.logout);
            removeStorage(KEYS.warn);
            removeStorage(KEYS.expires);

            bindEvents();

            if (HAS_LOCKS) {
                let becameLeader = false;

                navigator.locks.request('mefa-session-leader', { mode: 'exclusive' }, async function () {
                    lockHeld = true;
                    becameLeader = true;
                    touchSession(true);

                    return new Promise(function () {});
                });

                setTimeout(function () {
                    if (!becameLeader) {
                        syncTimersFromStoredExpiration();
                    }
                }, 500);

                return;
            }

            setTimeout(function () {
                if (isLeader()) {
                    touchSession(true);
                }
            }, Math.floor(Math.random() * 500));

            leaderTimer = setInterval(function () {
                renewLeadership();
            }, LEADER_REFRESH_MS);
        }

        window.mefaLogout = function () {
            apiLogout(3);
        };

        function clearStaleSessionState() {
            removeStorage(KEYS.logout);
            removeStorage(KEYS.warn);
        }


        initSessionManager();

        $(document).on('click', '.timeout .continue', function (e) {
            e.preventDefault();
            if (checkTimer) { clearTimeout(checkTimer); checkTimer = null; }
            hideWarning();
            setStorage(KEYS.lastActivity, { tab: TAB_ID, at: now(), user: true });
            touchSession(true);
        });

    })(jQuery);

}

jQuery(document).on('click', '.timeout .continue', function (e) {
    e.preventDefault();
    jQuery('#overlay').remove();
});